import { app } from '../../../bootstrap/core';
import { twoFactorModalComponent } from './twoFactorModal.component';
import './twoFactorModal.tpl.html';

app.component('twoFactorProtection', twoFactorModalComponent);
